import InputAutoCompleteValue from './InputAutoCompleteValue';

export default InputAutoCompleteValue;